/**
 * Bonus Replacer Collection
 */

define(function(require, exports, module) {
    'use strict';

    const $ = require('j');
    const _ = require('underscore');
    const config = require('config');
    const server = require('server');
    const BaseModel = require('common/base.model');
    const bonusMixin = require('mixins/bonus.mixin');
    const BaseCollection = require('common/base.collection');

    module.exports = BaseCollection.extend({

        mixins: [bonusMixin],

        model: BaseModel.extend({
            idAttribute: 'remoteBonusId'
        }),

        triggerTypes: [
            'signup',
            'deposit',
            'promotioncode',
            'customevent',
            'buybonus',
            'bonuscompletion',
            'campaign',
            'gameplay',
            'manual'
        ],

        bonusConfig: null,

        tcPreferences: null,

        cachedPageId: null,

        bonusTemplates: {},

        statusFilter: 'all',

        isTemplatesFetched: false,

        initialize: function() {
            this.bonusConfig = _.indexBy(config.get('bonusesConfiguration'), 'bonusCode');

            this.tcPreferences = {
                mapping: _.indexBy(config.get('bonusManagementTCPreferences.bonusTcMapping'), 'bonusCode'),
                defaultWcId: config.get('bonusManagementTCPreferences.defaultTermsAndCondWcId')
            };
        },

        sync: function(method, collection, options) {
            if (method === 'read') {
                if (options.remove) {
                    this.cachedPageId = null;
                }

                return $.when(
                    this.getBonuses(this.cachedPageId),
                    this.getBonusTemplates()
                ).done(({ data: { bonuses = [], paging = {}}}, bonusTemplates) => {
                    this.cachedPageId = paging.nextPageId;

                    options.success({ bonuses, bonusTemplates });
                }).fail(options.error);
            }
        },

        parse: function({ bonuses = [], bonusTemplates }) {
            if (bonusTemplates) {
                this.bonusTemplates = _.indexBy(bonusTemplates, 'code');
            }

            return bonuses.map(bonus => {
                const { acceptDate, endDate, templateCode } = bonus;
                const bonusTmpl = this.bonusTemplates[templateCode] || {};
                const { parseImsDate } = window.Playtech.API.formatter;

                return {
                    ...bonus,
                    ...acceptDate && parseImsDate(acceptDate),
                    ...endDate && parseImsDate(endDate),
                    bonusName: this.setBonusName(bonusTmpl, bonus)
                };
            });
        },

        getBonuses: function(pageId) {
            const fromDate = new Date();
            const toDate = new Date(fromDate);
            const statusFilter = this.statusFilter;
            const { getDateForIms } = window.Playtech.API.formatter;

            fromDate.setFullYear(fromDate.getFullYear() - 10);

            return server.send({
                ID: 31863,
                description: 'Search Player Bonuses',
                responses: [31864, 31865],
                paging: {
                    pageSize: 30,
                    pageId: pageId || '0'
                },
                playerBonusCriteria: {
                    ...statusFilter !== 'all' && { statusFilter },
                    issuedAfterDate: getDateForIms(fromDate),
                    issuedBeforeDate: getDateForIms(toDate)
                }
            });
        },

        getBonusTemplates: function() {
            let bonusTemplates = [];
            const bonusTemplatesState = $.Deferred();

            if (this.isTemplatesFetched) {
                return null;
            }

            const loadBonusTemplates = (pageId) => {
                server.send({
                    ID: 31143,
                    responses: [31144, 31145],
                    description: 'Search Player Available Bonus Templates',
                    promotionCode: '',
                    ...pageId ? { pageId } : {},
                    pageSize: 450,
                    triggerTypes: this.triggerTypes
                }).done((response) => {
                    const { matchingBonusTemplates, nextPageId } = response.data || {};

                    bonusTemplates = [...bonusTemplates, ...matchingBonusTemplates];

                    if (nextPageId) {
                        return loadBonusTemplates(nextPageId);
                    }

                    this.isTemplatesFetched = true;
                    bonusTemplatesState.resolve(bonusTemplates);
                }).fail((error) => bonusTemplatesState.reject(error));
            };

            loadBonusTemplates();

            return bonusTemplatesState;
        },

        cancelBonus: function(bonusInstanceCode) {
            return server.send({
                ID: 35577,
                reason: 'CancelByPlayer',
                responses: [35578, 35579],
                description: 'Remove bonus',
                bonusInstanceCode: bonusInstanceCode
            });
        }
    });
});
